<template>
  <div class="events-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EventsIndex'
}
</script>

<style scoped>
.events-container {
  padding: 20px;
}
</style>
